import React from "react";
import { useQuickSightAD } from "@/hooks/useADReports";
import AWSReportsTemplate from "@/components/templates/AWSReportsTemplate";
import QuickSightADDashboard from "@/components/organisms/ADDashboard";

function ADReports() {
  const { embedUrl, loading, error, refetch } = useQuickSightAD();

  return (
    <AWSReportsTemplate
      title="Active Directory (AD)"
      loading={loading}
      error={error}
      onRetry={refetch}
      hideFilters={true}
      hideDownload={true}
    >
      <QuickSightADDashboard />
    </AWSReportsTemplate>
  );
}

export default ADReports;
